import { render, staticRenderFns } from "./SupportChatHeadsGrip.vue?vue&type=template&id=3ab9bd84&scoped=true&"
import script from "./SupportChatHeadsGrip.vue?vue&type=script&lang=ts&"
export * from "./SupportChatHeadsGrip.vue?vue&type=script&lang=ts&"
import style0 from "./SupportChatHeadsGrip.vue?vue&type=style&index=0&id=3ab9bd84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab9bd84",
  null
  
)

export default component.exports